import Phaser from 'phaser';

export default class WellDoneScene extends Phaser.Scene {
    constructor() {
        super({ key: 'WellDoneScene' });
    }

    create(): void {
        const { width, height } = this.scale;
        
        this.add.text(width / 2, height / 2, 'WELL DONE!', {
            fontSize: '48px',
            color: '#fff'
        }).setOrigin(0.5);
    }
} 